import React from 'react';

import BaseJoinTypeCardGrid from './BaseJoinTypeCardGrid';
import {
  JOIN_TYPE_ORDERED,
  JOIN_TYPE_TO_DESCRIPTION,
  JOIN_TYPE_TO_IMAGE,
  JOIN_TYPE_TO_TITLE,
  JoinType,
} from './JoinConstants';

interface JoinTypeSelectorProps {
  joinType: JoinType | null;
  onSelectJoinType: (joinType: JoinType) => void;
  disabled?: boolean;
}

export default function JoinTypeSelector({
  joinType,
  onSelectJoinType,
  disabled,
}: JoinTypeSelectorProps): JSX.Element {
  return (
    <BaseJoinTypeCardGrid
      value={joinType}
      onSelect={onSelectJoinType}
      orderedValues={JOIN_TYPE_ORDERED}
      valueToTitle={JOIN_TYPE_TO_TITLE}
      valueToDescription={JOIN_TYPE_TO_DESCRIPTION}
      valueToImageUrl={JOIN_TYPE_TO_IMAGE}
      disabled={disabled}
    />
  );
}
